const DEFAULT_SORT = {
  property: 'exampleNo',
  direction: 'ASC',
};

export default DEFAULT_SORT;
